import React from 'react';
import { connect } from 'react-redux';
import { saveStates } from '@/constants/lifecycle';
import DatasetDictionary from './DatasetDictionary';
import DatasetWizardContentContainer from '../../components/DatasetWizardContentContainer';
import { resolveCatalogueTemplate } from '../../catalogue/helper';
import { updateDatasetProperties } from '../../actions';

const AddDatasetDictionaries = ({
  category,
  code,
  readErrors,
  saveErrors,
  title,
  updateProperties,
}) => (
  <DatasetWizardContentContainer
    category={category}
    className="aridhia-add-dataset-dictionaries"
    code={code}
    readErrors={readErrors}
    saveErrors={saveErrors}
    title={title}
    updateProperties={updateProperties}
  >
    <DatasetDictionary code={code} category={category} />
  </DatasetWizardContentContainer>
);

const mapStateToProps = ({
  datasets: { datasets },
  catalogues: { templates },
}, ownProps) => {
  const { dataset } = resolveCatalogueTemplate(datasets, templates, ownProps, {
    ...saveStates,
  });

  return {
    saveErrors: dataset.saveErrors,
  };
};

const mapDispatchToProps = {
  updateProperties: updateDatasetProperties,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddDatasetDictionaries);
